<template>
  <div class="discussBox" ref="discussBox" id="discussBox" v-if="this.commentlists.length > 0">
    <p class="fgx" v-if="commonType!='keepRecord'"></p>
    <h4 class="ggTit">全部评论</h4>
    <div class="list-content" id="list-content">
      <div class="list-item">
        <van-cell v-for="item in commentlists" :key="item.id" class="item">
          <div class="critic">
            <dl class="criticInfo" @click="getAppComment(item)">
              <dt class="criticImg">
                <img :src="item.readerImg" alt />
              </dt>
              <dd class="criticName">{{item.readerName}}【{{item.commentTime}}】</dd>
              <dd class="criticmain">{{item.content}}</dd>
            </dl>

            <van-cell v-for="childItem in item.children" :key="childItem.id" class="childItem">
              <div class="critic">
                <dl class="criticInfo" @click="getAppComment(childItem)">
                  <dt class="criticImg">
                    <img :src="childItem.readerImg" alt />
                  </dt>
                  <dd
                    class="criticName"
                  >{{childItem.readerName}} 回复 {{childItem.beReaderName}}【{{childItem.commentTime}}】</dd>
                  <dd class="criticmain">{{childItem.content}}</dd>
                </dl>
              </div>
            </van-cell>
          </div>
        </van-cell>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "discussBox",
  props: ["ktId", "allowComment"],
  data() {
    return {
      commentlists: [],
      contentId: "", //评论所属id
      commonType:"",//评论所属类型
      clientType: "", //手机类型
    };
  },

  mounted() {
    window.commentReload = this.reloadPage;
     this.commonType = this.$route.query.commonType;
    this.clientType = getDeviceType();
    this.$nextTick(() => {
      this.contentId = this.ktId;
      if (this.contentId) {
        this.getTest();
      }
      if (this.allowComment) {
        this.discussShow();
      }
    });
  },
  methods: {
    //渲染评论列表
    getTest() {
      let _this = this;
      console.log(_this.commonType)
      _this.$api.baseCommon.baseMsg.getCommentList(_this.commonType,_this.contentId)
        .then(res => {
          if (res.code == "1") {
            _this.commentlists = res.data;
          } else {
            console.log(res.msg);
          }
        })
        .catch(err => {
          this.finished = true;
          console.log(err);
        });
    },
    getAppComment(data) {
      
      if (this.clientType == "android") {
        window.android.getInfo(109, JSON.stringify(data));
      } else {
        //IOS
        window.webkit.messageHandlers.setCommentBox.postMessage(
          JSON.stringify(data)
        );
      }
    },
    discussShow() {
      //获取评论框
      if (this.clientType == "android") {
        window.android.getInfo(108);
      } else {
        //IOS
        window.webkit.messageHandlers.getCommentBox.postMessage(null);
      }
    },
    reloadPage: function() { 
      this.commentlists = [];
      setTimeout(() => {
        this.getTest();
      }, 300);
    }
  },
  watch: {
    ktId: function(newVal) {
      this.contentId = newVal;
      if (this.contentId) {
        this.getTest();
      }
    },
    allowComment: function(newVal) {
      if (newVal) {
        this.discussShow();
      }
    }
  }
};
</script>

<style lang="less">
@import "./css/discussBox.less";
</style>
